import index from './aspect'

export default index